import { lazy } from 'react'

// Route pages load on demand.
const SubcontractModules = {
    List: lazy(() => import('./components/List')),
    Detail: lazy(() => import('./components/Detail')),
}
export default SubcontractModules
